
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/signal/reporting-returns",
      function () {
        return require("private-next-pages/docs/signal/reporting-returns.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/signal/reporting-returns"])
      });
    }
  